export type Testimonial = {
  initials: string
  name: string
  location: string
  product: string
  text: string
}

export const featuredTestimonial: Testimonial = {
  initials: 'MG',
  name: 'María G.',
  location: 'Córdoba',
  product: 'Terapeuta en Medicina Tradicional China',
  text: 'Por primera vez tengo una herramienta visual que puedo abrir en consulta y mostrarle al paciente exactamente qué punto voy a trabajar y por qué. La autoridad que transmite es inmediata.',
}

export const testimonials: Testimonial[] = [
  {
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Terapeuta holística',
    text: 'Por primera vez tengo un sistema completo y visual para aplicar acupuntura con criterio clínico real. Mis pacientes ven exactamente qué punto trabajo y por qué. La confianza que genera es inmediata y total.',
  },
  {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Especialista en MTC',
    text: 'El nivel de detalle técnico de cada protocolo es impresionante. Tiene la claridad de un material para alguien que empieza y la profundidad técnica que exige un especialista. No existe nada igual en español.',
  },
  {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta en formación',
    text: 'Recién me estaba iniciando en la práctica clínica y el Atlas me dio la estructura, la seguridad y el respaldo visual que necesitaba desde el primer paciente. Los bonos de Psicosomática y Auriculoterapia solos valen todo el pack.',
  },
  {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Terapeuta holístico',
    text: 'El bono de Farmacopea Externa me abrió una dimensión que no imaginaba. Ahora combino aceites esenciales con los puntos del atlas y la profundidad de mis sesiones es completamente diferente. Mis pacientes lo perciben desde la primera sesión.',
  },
]
